export default __webpack_public_path__ + "static/media/suspend-1.b4b9c82a.png";